export class ProfileInfo {
    activeProfiles: string[];
    ribbonEnv: string;
    inProduction: boolean;
    swaggerEnabled: boolean;
}



// WEBPACK FOOTER //
// ./src/app/layouts/profiles/profile-info.model.ts